<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">
      <div class="reference_table">
     <div class="container">
      <div class="top">
        <div class="row">
          <div class="col-md-8">
            <nav aria-label="breadcrumb" class="mt-4">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"> <h3 >Scholarship Excel Upload<em class="ti-info-alt ml-3" style="font-size: 12px;"></em> </h3></li>  
              </ol>
            </nav>

          </div>
          <div class="col-md-4">
            <div class=" pull-right">
              <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                <mat-button-toggle value="grid" (click)="onBack()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back to Scholarship</mat-button-toggle>

              </mat-button-toggle-group>
              <!-- <button mat-raised-button color="primary"  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
             </div>
          </div>
        </div>



      </div>
      <!-- <h3 class="m-4"></h3> -->
      <div class="top mt-5" *ngIf="!managementRecords">
        <button class="top_button mr-3" (click)="filePicker.click()">
          Upload Excel Lists<em class="ti-upload ml-3"></em> 
        </button>
        <button class="top_button" (click)="downloadFile()">
          Download Excel Format <em class="ti-cloud-down ml-3"></em> 
        </button>

        <input
          #filePicker
          style="visibility:hidden;"
          type="file"
          (change)="onFileChange($event)"
        />

      </div>

      <div class="table-responsive" *ngIf="managementRecords">
        <table class="tabular">
          <thead class="thead">
            <tr>
              <th class="head">S/N</th>
              <th class="head">Scholarship Category</th>
              <th class="head">Scholarship Type</th>
              <th class="head">Beneficiary Surname</th>
              <th class="head">Beneficiary Firstname</th>
              <th class="head">Beneficiary Firstname</th>
              <th class="head">Scholarship Date</th>
              <th class="head">Scholarship Award No.</th>
              <th class="head">Scholarship Application No.</th>
              <th class="head">Scholarship Session</th>
              <th class="head">Gender</th>
              <th class="head">DOB</th>
              <th class="head">Address</th>
              <th class="head">School</th>
              <th class="head">Course of Study</th>
              <th class="head">Duration</th>
              <th class="head">State</th>
              <th class="head">LGA</th>
              <th class="head">Community</th>
              <th class="head">Phone</th>
              <th class="head">Institution Country (B/A)</th>
              <th class="head">Institution State (B/A)</th>
              <th class="head">Institution LGA (B/A)</th>
              <th class="head">Institution Community (B/A)</th>
              <th class="head">Contact Person</th>
              <th class="head">Contact Person Phone</th>
              <th class="head">Contact Email</th>
              <th class="head">Remark (B/A)</th>
              <th class="head">Institution Name (B/A)</th>
              <th class="head">Institution Address (B/A)</th>
              <th class="head">Contact Person (O/A)</th>
              <th class="head">Contact Person Phone (O/A)</th>
              <th class="head">Contact Email (O/A)</th>
              <th class="head">Contact Url (O/A)</th>
              <th class="head">Institution Address (O/A)</th>
              <th class="head">Institution Address (O/A)</th>
              <th class="head">Institution Country (O/A)</th>
              <th class="head">Institution State (O/A)</th>
              <th class="head">Institution LGA (O/A)</th>
              <th class="head">Institution Community (O/A)</th>
              <th class="head">Remark (O/A)</th>
              <!-- <th class="head">Action</th> -->
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let scholarshipManagement of managementRecords;
                index as i
              "
            >
              <td>{{ i + 1 }}</td>
              <td
                *ngIf="
                  checkScholarshipCategory(
                    scholarshipManagement?.ScholarshipCategory
                  );
                  else noCategory
                "
              >
                {{ scholarshipManagement?.ScholarshipCategory }}
              </td>

              <ng-template #noCategory>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Scholarship category not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.ScholarshipCategory }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkScholarshipType(
                    scholarshipManagement?.ScholarshipType
                  );
                  else noType
                "
              >
                {{ scholarshipManagement?.ScholarshipType }}
              </td>

              <ng-template #noType>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Scholarship type not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.ScholarshipType }}
                </td>
              </ng-template>

              <td>{{ scholarshipManagement.BeneficiarySurname }}</td>
              <td>{{ scholarshipManagement.BeneficiaryFirstname }}</td>
              <td>{{ scholarshipManagement.BeneficiaryOthername }}</td>
              <td>{{ scholarshipManagement.ScholarshipDate }}</td>
              <td>{{ scholarshipManagement.ScholarshipAwardNo }}</td>
              <td>{{ scholarshipManagement.ScholarshipApplicationNo }}</td>
              <td
                *ngIf="
                  checkScholarshipSession(
                    scholarshipManagement?.ScholarshipYear
                  );
                  else noYear
                "
              >
                {{ scholarshipManagement?.ScholarshipYear }}
              </td>

              <ng-template #noYear>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Scholarship year not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.ScholarshipYear }}
                </td>
              </ng-template>
              <td
                *ngIf="
                  checkGender(scholarshipManagement?.Gender);
                  else noGender
                "
              >
                {{ scholarshipManagement?.Gender }}
              </td>

              <ng-template #noGender>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Gender not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.Gender }}
                </td>
              </ng-template>
              <td>{{ scholarshipManagement.DateOfBirth }}</td>
              <td>{{ scholarshipManagement.Address }}</td>
              <td>{{ scholarshipManagement.School }}</td>
              <td
                *ngIf="
                  checkCourseOfStudy(scholarshipManagement?.CourseOfStudy);
                  else noCourse
                "
              >
                {{ scholarshipManagement?.CourseOfStudy }}
              </td>

              <ng-template #noCourse>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Course of study not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.CourseOfStudy }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkScholarshipAwardDuration(
                    scholarshipManagement?.ScholarshipAwardDuration
                  );
                  else noAward
                "
              >
                {{ scholarshipManagement?.ScholarshipAwardDuration }}
              </td>

              <ng-template #noAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Scholarship award duration not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.ScholarshipAwardDuration }}
                </td>
              </ng-template>

              <td
                *ngIf="checkState(scholarshipManagement?.State); else noState"
              >
                {{ scholarshipManagement?.State }}
              </td>

              <ng-template #noState>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="State not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.State }}
                </td>
              </ng-template>

              <td *ngIf="checkLga(scholarshipManagement?.LGA); else noLGA">
                {{ scholarshipManagement?.LGA }}
              </td>

              <ng-template #noLGA>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="LGA not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.LGA }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkCommunity(scholarshipManagement?.Community);
                  else noCommunity
                "
              >
                {{ scholarshipManagement?.Community }}
              </td>

              <ng-template #noCommunity>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Community not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.Community }}
                </td>
              </ng-template>

              <td>{{ scholarshipManagement.PhoneNumber }}</td>

              <td
                *ngIf="
                  checkCountry(
                    scholarshipManagement?.InstitutionCountryBeforeAward
                  );
                  else noCountryBeforeAward
                "
              >
                {{ scholarshipManagement?.InstitutionCountryBeforeAward }}
              </td>

              <ng-template #noCountryBeforeAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution country before award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionCountryBeforeAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkState(
                    scholarshipManagement?.InstitutionStateBeforeAward
                  );
                  else StateBeforeAward
                "
              >
                {{ scholarshipManagement?.InstitutionStateBeforeAward }}
              </td>

              <ng-template #StateBeforeAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution state before award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionStateBeforeAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkLga(scholarshipManagement?.InstitutionLGABeforeAward);
                  else LGABeforeAward
                "
              >
                {{ scholarshipManagement?.InstitutionLGABeforeAward }}
              </td>

              <ng-template #LGABeforeAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution LGA before award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionLGABeforeAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkCommunity(
                    scholarshipManagement?.InstitutionCommunityBeforeAward
                  );
                  else CommunityBeforeAward
                "
              >
                {{ scholarshipManagement?.InstitutionCommunityBeforeAward }}
              </td>

              <ng-template #CommunityBeforeAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution community before award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionCommunityBeforeAward }}
                </td>
              </ng-template>

              <td>{{ scholarshipManagement.ContactPerson }}</td>
              <td>{{ scholarshipManagement.ContactPhoneNo }}</td>
              <td>{{ scholarshipManagement.ContactEmail }}</td>
              <td>{{ scholarshipManagement.RemarksBeforeAward }}</td>
              <td>{{ scholarshipManagement.InstitutionNameBeforeAward }}</td>
              <td>
                {{ scholarshipManagement.InstitutionAddressBeforeAward }}
              </td>
              <td>{{ scholarshipManagement.ContactPersonOnAward }}</td>
              <td>{{ scholarshipManagement.ContactPhoneNoOnAward }}</td>
              <td>{{ scholarshipManagement.ContactEmailOnAward }}</td>
              <td>{{ scholarshipManagement.ContactUrlOnAward }}</td>
              <td>{{ scholarshipManagement.InstitutionNameOnAward }}</td>
              <td>{{ scholarshipManagement.InstitutionAddressOnAward }}</td>

              <td
                *ngIf="
                  checkCountry(
                    scholarshipManagement?.InstitutionCountryOnAward
                  );
                  else noCountryOnAward
                "
              >
                {{ scholarshipManagement?.InstitutionCountryOnAward }}
              </td>

              <ng-template #noCountryOnAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution country on award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionCountryOnAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkState(scholarshipManagement?.InstitutionStateOnAward);
                  else StateOnAward
                "
              >
                {{ scholarshipManagement?.InstitutionStateOnAward }}
              </td>

              <ng-template #StateOnAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution state on award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionStateOnAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkLga(scholarshipManagement?.InstitutionLGAOnAward);
                  else LGAOnAward
                "
              >
                {{ scholarshipManagement?.InstitutionLGAOnAward }}
              </td>

              <ng-template #LGAOnAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution LGA on award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionLGAOnAward }}
                </td>
              </ng-template>

              <td
                *ngIf="
                  checkCommunity(
                    scholarshipManagement?.InstitutionCommunityOnAward
                  );
                  else CommunityOnAward
                "
              >
                {{ scholarshipManagement?.InstitutionCommunityOnAward }}
              </td>

              <ng-template #CommunityOnAward>
                <td
                  class="new_data alert alert-danger"
                  matTooltip="Institution community on award award not found"
                  [matTooltipPosition]="position.value"
                >
                  {{ scholarshipManagement?.InstitutionCommunityOnAward }}
                </td>
              </ng-template>

              <td>{{ scholarshipManagement.RemarksOnAward }}</td>

              <!-- <td>
            <button class="delete_icon trash">
              <em class="ti-trash"> </em> 
            </button>
          </td> -->
            </tr>
          </tbody>
        </table>
      </div>

      <!-- <form [formGroup]="countryForm"> -->

      <div class="submit" *ngIf="managementRecords">
        <button class="submit_button" (click)="onSubmit()">
          Submit
        </button>
      </div>
      <!-- </form> -->
     </div>
      </div>
    </div>
  </main>
</div>
